import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import { setInterval } from 'timers';

class ThankYou extends Component {
  render() {
    let count = 1
    setInterval(function () {
      count = count + 1
      if (count > 8) {
        window.location.href = '/'
      }
    }, 1000)
    return (
      <section className="generic-padding hero-online-wrapper">
        <Helmet>
          <title>PUYD | Gulf Oil India</title>
        </Helmet>
        <Container>
          <Header />
          <div className="text-center py-5">
            <p className="font-size-5">Thank you for submitting your details.</p>
            <p>Please carry a print out of the registration email sent to your inbox for the on-ground trials in your city.</p>
            <p><Link to="/">Go Back to Home</Link></p>
          </div>
        </Container>
      </section>
    );
  }
}

export default ThankYou;